export const styles = {
  Checkbox: {
    margin: 0
  }
};
